﻿//import { Component, ViewChild, ElementRef   } from "@angular/core";
import { Component, ViewChild, ElementRef   } from "@angular/core";
import { ActivatedRoute,Router} from "@angular/router";
import { DataTable } from "angular2-datatable";
import { DataService } from "../services/dataService";
import { ValidationMessage } from "../validation/validationMessage";
import { ValidationMessageType } from "../validation/validationMessageType";
import {SearchCasesFilterPipe} from "../pipes/searchCases-filter.pipe";
import { SearchCases } from "../models/searchcasesfilter.model";
import { Modal } from "../shared/dialog/dialog.component";
import { ModalService } from "../shared/dialog/dialog.service";


declare let jsPDF;
declare var $: any;
@Component({
    host: { "(document: keyup)": "keyup($event)" },
    selector: "jax-searchcasescomponent",
    templateUrl: "./searchCases.component.html",
})
export class SearchCasesComponent  {
    public data;
    public searchCasesClicked: boolean;
    public sortBy = "FirstName";
    public sortOrder = "asc";
    public rowsOnPage = 10;
    public searchCompleted = false;
    public hasError = false;
    public totalRecord = 0;
    public dtable: DataTable;
    public isCaseDetail = false;
    public errorMessage: string;
    public validationMessage: ValidationMessage;
    public cases: SearchCases= new SearchCases();
    public currentUser: any;
    private MODAL_ID: string;
    public searchFields: CaseSearchFields[] = new Array();
    public searchFieldId: string = "";
    public restrictedCases: any;
    public isCaseRestriced: boolean = false;
    public isCaseSevered: boolean = false;

    public filterQuery0: string;
    public filterQuery1: string;
    public filterQuery2: string;
    public filterQuery3: string;
    public filterQuery4: string;
    public filterQuery5: string;
    public filterQuery6: string;
    public filterQuery7: string;
    public filterQuery8: string;
    public filterQuery9: string;
    

    @ViewChild('gridElement') el: ElementRef;


    constructor(private route: ActivatedRoute,
        private dataService: DataService,
        private modalService: ModalService,
        private router: Router) {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));


        if (this.currentUser) {
            this.cases.UserID = this.currentUser.UserId;
            this.getRestricatedCases();
        }
        this.MODAL_ID = "uploaddocument";
        this.getSearchFields();

        if(this.dataService.sharedService.searchCaseFilter.CaseNumber || this.dataService.sharedService.searchCaseFilter.ChildNumber 
        || this.dataService.sharedService.searchCaseFilter.DOB || this.dataService.sharedService.searchCaseFilter.FileNumber
        || this.dataService.sharedService.searchCaseFilter.FirstName || this.dataService.sharedService.searchCaseFilter.LastName){
            this.cases = this.dataService.sharedService.searchCaseFilter;
            this.searchCases();
        }
    }

    private getRestricatedCases() {
        this.dataService.get("Cases/restrictedcases?userId=" + this.currentUser.UserId).subscribe(resp => {
            this.restrictedCases = resp;
        });
    }

    public convertToPdf() {

        var columns = [
            { title: "Case #", dataKey: "CaseNumber" },
            { title: "First Name", dataKey: "FirstName" },
            { title: "Middle Name", dataKey: "MiddleName" },
            { title: "Last Name", dataKey: "LastName" },
            { title: "DOB", dataKey: "DOB" },
            { title: "Sex", dataKey: "Sex" },
            { title: "Case Type", dataKey: "CaseType" },
            { title: "File Number", dataKey: "FileNumber" },
            { title: "SWID", dataKey: "SWIDNumber" },
            { title: "CHILDS Case #", dataKey: "ChildNumber" }
        ];

        var doc = new jsPDF('l', 'pt');

        let searchpipe = new SearchCasesFilterPipe();
        let filterdata = searchpipe.transform(this.data,
            'CaseNumber~' +
            this.filterQuery0 +
            ',' +
            'FirstName~' +
            this.filterQuery1 +
            ',' +
            'MiddleName~' +
            this.filterQuery2 +
            ',' +
            'LastName~' +
            this.filterQuery3 +
            ',' +
            'DOB~' +
            this.filterQuery4 +
            ',' +
            'Sex~' +
            this.filterQuery5 +
            ',' +
            'CaseType~' +
            this.filterQuery6 +
            ',' +
            'FileNumber~' +
            this.filterQuery7 +
            ',' +
            'ChildNumber~' +
            this.filterQuery8 +
            ',' +
            'SWIDNumber~' +
            this.filterQuery9);

        doc.autoTable(columns,
            filterdata,
            {
                styles: {},
                columnStyles: {
                    id: {}
                },
                createdCell(cell) {
                    // prevent 'null' as text in table columns
                    if (!cell.raw) {
                        cell.text = "";
                    }
                },
                margin: { top: 60 },
                addPageContent: function() {

                    doc.text("Case List", 40, 30);
                }
            });
        doc.save("caselist.pdf");
    }

    public searchCases() {
        this.isCaseRestriced = false;
        this.searchCasesClicked = true;
        this.searchCompleted = false;
        this.data = "";
        this.totalRecord = 0;

        if (!this.validateSearchCriteria()) {
            this.dataService.sharedService.searchCaseFilter=this.cases;
            this.dataService.post("Cases/searchcases", JSON.stringify(this.cases)).subscribe(
                (response) => {
                        this.data = response;
                    
                    this.totalRecord = this.data.length;
                    this.searchCompleted = true;
                    this.errorMessage = "";
                },
                (error) => {
                    this.errorMessage = error.message;
                    this.searchCompleted = true;
                    this.hasError = true;
                });
        } else {
            this.searchCasesClicked = false;
        }
    }

    public validateSearchCriteria() {
        this.isCaseRestriced = false;
        this.validationMessage = null;
        let msg = new ValidationMessage();
        msg.messageType = ValidationMessageType.Error;
        let isError = false;
        if ((this.isValid(this.cases.FirstName) && !this.isValid(this.cases.LastName)) ||
            (this.isValid(this.cases.LastName) && !this.isValid(this.cases.FirstName))) {
            isError = true;
        } else if ((!this.isValid(this.cases.FirstName) || !this.isValid(this.cases.LastName)) &&
            !this.isValid(this.cases.CaseNumber) &&
            !this.isValid(this.cases.ChildNumber) &&
            !this.isValid(this.cases.FileNumber) &&
            !this.isValid(this.cases.DOB)) {
            isError = true;
        }
        if (isError) {
            msg.message =
                "<ul>Atleast one of the following are required<li>Both First Name and Last Name</li><li>Case Number</li><li>Child Case#</li><li>File Number or SWID Number</li><li>Date of Birth</li></ul>";
            this.validationMessage = msg;
        } else {
            $.fn.collapse("#search", "#searchresult");
        }
        return isError;
    }

    public clearSearch() {
        this.cases.FirstName = null;
        this.cases.LastName = null;
        this.cases.DOB = null;
        this.cases.FileNumber = null;
        this.cases.CaseNumber = null;
        this.cases.ChildNumber = null;
        this.data = "";
        this.totalRecord = this.data.length;
        this.searchCasesClicked = false;
        this.validationMessage = null;
        this.isCaseRestriced = false;
    }

    private isValid(val: any) {
        return (val !== "undefined" && val);
    }

    public onChange(pageEvent: any) {
        this.isCaseRestriced = false;
        this.totalRecord = pageEvent.dataLength;
        this.rowsOnPage > 15 ? this.rowsOnPage = 10 : this.rowsOnPage = this.rowsOnPage;
    }

    public onSelectCase(caseNumber: string, caseId: number, roleId: number, caseType:string) {

        this.isCaseRestriced = this.restrictedCases.some(r => r === caseId);
        this.isCaseSevered = this.data.some(c => c.CaseID === caseId && c.IsSeveranceCase==true);

        if (this.isCaseRestriced || this.isCaseSevered) {
            return;
        }

        if (caseNumber) {
            this.router.navigate(["../casedetail"],
                { relativeTo: this.route, queryParams: { CaseNumber: caseNumber, CaseID: caseId, RoleID: roleId, CaseType:caseType }, skipLocationChange: true  });
        }
    }

    private keyup(event: KeyboardEvent): void {
        if (event.keyCode === 13) {
            this.searchCases();
        }
   }

    public getSearchFields(): void {
        let casefield = new CaseSearchFields();
        this.searchFields.push(casefield);
        casefield = new CaseSearchFields();
        casefield.Id = "filterQuery0";
        casefield.Name = "CaseNumber";
        this.searchFields.push(casefield);

        casefield = new CaseSearchFields();
        casefield.Id = "filterQuery1";
        casefield.Name = "FirstName";
        this.searchFields.push(casefield);

        casefield = new CaseSearchFields();
        casefield.Id = "filterQuery2";
        casefield.Name = "MiddleName";
        this.searchFields.push(casefield);

        casefield = new CaseSearchFields();
        casefield.Id = "filterQuery3";
        casefield.Name = "LastName";
        this.searchFields.push(casefield);

        casefield = new CaseSearchFields();
        casefield.Id = "filterQuery4";
        casefield.Name = "DOB";
        casefield.Type = "Date";
        this.searchFields.push(casefield);

        casefield = new CaseSearchFields();
        casefield.Id = "filterQuery5";
        casefield.Name = "Sex";
        this.searchFields.push(casefield);

        casefield = new CaseSearchFields();
        casefield.Id = "filterQuery6";
        casefield.Name = "CaseType";
        this.searchFields.push(casefield);

        casefield = new CaseSearchFields();
        casefield.Id = "filterQuery7";
        casefield.Name = "FileNumber";
        this.searchFields.push(casefield);

        casefield = new CaseSearchFields();
        casefield.Id = "filterQuery8";
        casefield.Name = "SWIDNumber";
        this.searchFields.push(casefield);

        casefield = new CaseSearchFields();
        casefield.Id = "filterQuery9";
        casefield.Name = "ChildNumber";
        this.searchFields.push(casefield);
    }

    public getSelectedField(id: string) {
        var obj = this.searchFields.find(n => n.Id === id);
        return obj;
    }

    public setCaseNumber() {
        this.isCaseRestriced = false;
    }
}

export class CaseSearchFields {
    public Id: string;
    public Name: string;
    public Type: string;
    constructor() {
        this.Id = "";
        this.Name = "--Select--";
        this.Type = "string";
    }
}